import { render } from "./LogoComponent.vue?vue&type=template&id=96c9f77c&scoped=true&ts=true"
import script from "./LogoComponent.vue?vue&type=script&lang=ts"
export * from "./LogoComponent.vue?vue&type=script&lang=ts"

import "./LogoComponent.vue?vue&type=style&index=0&id=96c9f77c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96c9f77c"]])

export default __exports__